import * as React from 'react';
import cx from 'classnames';
import { CnPopover } from '../cn-popover';
export class CnEllipsis extends React.Component {
    static displayName = 'CnEllipsis';
    static defaultProps = {
        ellipsisPosition: 'end',
        endCharCount: 8,
        hasTooltip: true,
    };
    textRef;
    constructor(props) {
        super(props);
        this.state = {
            isOverflow: false,
        };
    }
    componentDidMount() {
        if (this.props.ellipsisPosition === 'middle') {
            if (this.textRef && this.textRef.scrollWidth > this.textRef.offsetWidth) {
                this.setState({
                    isOverflow: true,
                });
            }
        }
    }
    onMouseEnter = () => {
        if (this.textRef && this.textRef.scrollWidth > this.textRef.offsetWidth) {
            this.setState({
                isOverflow: true,
            });
        }
        else {
            this.setState({
                isOverflow: false,
            });
        }
    };
    saveTextRef = (ref) => {
        this.textRef = ref;
    };
    render() {
        const { isOverflow } = this.state;
        const { children, className, ellipsisPosition, endCharCount, hasTooltip, cnTooltipProps, ...otherProps } = this.props;
        const classes = cx(className, {
            'cn-ui-m-ellipsis': true,
        });
        // 默认
        let trigger = (React.createElement("div", { onMouseEnter: this.onMouseEnter, className: classes, ...otherProps },
            React.createElement("div", { ref: this.saveTextRef, className: "cn-ui-m-ellipsis-header" }, children)));
        // 省略号出现在中间
        if (isOverflow && ellipsisPosition === 'middle') {
            const childrenStr = `${children}`;
            const startChildren = childrenStr.substr(0, childrenStr.length - endCharCount);
            const endChildren = childrenStr.substr(-endCharCount);
            trigger = (React.createElement("div", { className: classes, ...otherProps },
                React.createElement("div", { ref: this.saveTextRef, className: "cn-ui-m-ellipsis-header" }, startChildren),
                React.createElement("div", { className: "cn-ui-m-ellipsis-footer" }, endChildren)));
        }
        // 出现 Balloon
        if (isOverflow && hasTooltip) {
            return (React.createElement(CnPopover, { content: children, trigger: "click", placement: "top-start", mode: "dark", ...cnTooltipProps }, trigger));
        }
        return trigger;
    }
}
